import { render, staticRenderFns } from "./OrderListOrder.vue?vue&type=template&id=55c5efef&"
import script from "./OrderListOrder.vue?vue&type=script&lang=js&"
export * from "./OrderListOrder.vue?vue&type=script&lang=js&"
import style0 from "./OrderListOrder.vue?vue&type=style&index=0&id=55c5efef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports